import React, { memo } from 'react';
import * as Styled from './styled';

const LinkButton = ({ children, ...props }) => (
  <Styled.Wrapper {...props} noWrap component="button">{children}</Styled.Wrapper>
);

export default memo(LinkButton);